var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gallery-detail-link',{attrs:{"detailLayout":_vm.detailLayout,"galleryData":_vm.galleryData}})
}
var staticRenderFns = []

export { render, staticRenderFns }